// TODO Find if it's possible to replace with lodash.isObject
export const isObject = (obj: Record<string, any>) => {
  return obj === Object(obj);
};

export function isObjectEmpty(obj: Record<string, any> | undefined) {
  if (!obj) return true;
  return Object.keys(obj).length === 0;
}
